function Select (props) {
    return (
        <div className={props.col}>
            <div className="row m-3">
                <label 
                    htmlhtmlFor="static{props.name}" 
                    className="text-end fw-bold form-label px-1">
                        {props.title}
                </label>
                {
                    (props.multiple === true) ? (
                    <select 
                        multiple
                        style={{marginBottom: '2px'}}
                        value={props.value}
                        defaultValue={'DEFAULT'}
                        tabIndex={props.tab}
                        onChange={props.onchange}
                        className="form-control form-select form-select-lg shadow-none" 
                        aria-label="form-select-lg example" >
                        {
                            (props.status == 1) ? (
                                props.data.map((value,key) => (
                                    (key == 0) ? (
                                        <>
                                        <option key='DEFAULT' selected>یک مورد انتخاب کنید</option>
                                        {
                                            (props.target == 1) ? (
                                                <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                            ) : (
                                                <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                            )
                                        }
                                        </>
                                    ) : (
                                        <>
                                        {
                                            (props.target == 1) ? (
                                                <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                            ) : (
                                                <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                            )
                                        }
                                        </>
                                    )
                                ))
                            ) : (
                                props.data.map((value,key) => (
                                    (key == 0) ? (
                                        <>
                                        <option key='DEFAULT'>یک مورد انتخاب کنید</option>
                                        <option key={++key} value={++key}>{value}</option>
                                        </>
                                    ) : (
                                        <option key={++key} value={++key}>{value}</option>
                                    )
                                ))
                            )
                        }
                    </select>
                    ) : (
                        <select 
                            style={{marginBottom: '2px'}}
                            value={props.value}
                            defaultValue={'DEFAULT'}
                            tabIndex={props.tab}
                            onChange={props.onchange}
                            className="form-control form-select form-select-lg shadow-none" 
                            aria-label="form-select-lg example" >
                            {
                                (props.status == 1) ? (
                                    props.data.map((value,key) => (
                                        (key == 0) ? (
                                            <>
                                            <option key='DEFAULT' selected>یک مورد انتخاب کنید</option>
                                            {
                                                (props.target == 1) ? (
                                                    <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                                ) : (
                                                    <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                                )
                                            }
                                            </>
                                        ) : (
                                            <>
                                            {
                                                (props.target == 1) ? (
                                                    <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                                ) : (
                                                    <option key={++key} id={value.name} value={value.id}>{value.name}</option>
                                                )
                                            }
                                            </>
                                        )
                                    ))
                                ) : (
                                    props.data.map((value,key) => (
                                        (key == 0) ? (
                                            <>
                                            <option key='DEFAULT'>یک مورد انتخاب کنید</option>
                                            <option key={++key} value={++key}>{value}</option>
                                            </>
                                        ) : (
                                            <option key={++key} value={++key}>{value}</option>
                                        )
                                    ))
                                )
                            }
                        </select>
                    ) 
                }
                
                {
                    (props.errorName) ? (
                    <span className="help-block fw-bold d-inline-block mt-2">
                        <small className='text-danger validate-error'>{ props.errorName }</small>
                    </span>
                ):''}
            </div>
        </div>
    )
}

export default Select;